import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export default function Login() {
    const [formData, setFormData] = useState({
        username: '',
        password: ''
    });
    const [welcome, setWelcome] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setWelcome('');
        setIsLoading(true);
        
        try {
            // Try staff login first
            //  console.log({formData});
            const staffRes = await axios.post('https://sunrise-backend.sunrisemeditechsystems.com/api/staffusers/login', formData);
            console.log('Staff login response:', staffRes.data);
            if (staffRes.data.success) {
                // Staff login successful
                const userData = {
                    username: staffRes.data.username,
                    role: staffRes.data.role,
                    isStaff: true
                };
                localStorage.setItem('token', staffRes.data.token); // <-- add this line
                localStorage.setItem('userData', JSON.stringify(userData));
                
                if (staffRes.data.role === 'admin') {
                    setWelcome('Welcome Admin! Redirecting...');
                } else if (staffRes.data.role === 'receptionist') {
                    setWelcome('Welcome Receptionist! Redirecting...');
                } else if (staffRes.data.role === 'deliveryman') {
                    setWelcome('Welcome Deliveryman! Redirecting...');
                }
                
                setTimeout(() => {
                    navigate('/');
                }, 1500);
            } else {
                // Try regular user login
                const userRes = await axios.post('https://sunrise-backend.sunrisemeditechsystems.com/api/users/login', formData);
                console.log('User login response:', userRes.data);
                if (userRes.data.success) {
                    localStorage.setItem('token', userRes.data.token);
                    localStorage.setItem('userData', JSON.stringify({
                        username: userRes.data.username,
                        role: 'user',
                        isStaff: false
                    }));
                    setWelcome('Welcome! Redirecting...');
                    setTimeout(() => {
                        navigate('/');
                    }, 1500);
                } else {
                    setError('Invalid credentials');
                }
            }
        } catch (err) {
            setError('Login failed. Please try again.');
            console.error('Login error:', err);
        } finally {
            setIsLoading(false);
        }
    };

    return(
        <>
  {/* Begin page */}
  <div className="accountbg" />
  <div className="wrapper-page">
    <div className="card">
      <div className="card-body">
        <div className="card-logo">
          <a href="/" className="logo logo-admin">
            <img src="images/sunrise_logo.png" className='img-logo' alt="logo" />
          </a>
        </div>
        <div className="px-3 pb-3">
          <form className="form-horizontal m-t-20" onSubmit={handleSubmit}>
            <div className="form-group row">
              <div className="col-12">
                <input
                  className="form-control"
                  type="text"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  required
                  placeholder="Username"
                  disabled={isLoading}
                />
              </div>
            </div>
            <div className="form-group row">
              <div className="col-12">
                <input
                  className="form-control"
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  placeholder="Password"
                  disabled={isLoading}
                />
              </div>
            </div>
            <div className="form-group row">
              <div className="col-12">
                <div className="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="customCheck1"
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="customCheck1"
                  >
                    Remember me
                  </label>
                </div>
              </div>
            </div>
            <div className="form-group text-center row m-t-20">
              <div className="col-12">
                <button
                  className="btn btn-danger btn-block waves-effect waves-light"
                  type="submit"
                  disabled={isLoading}
                >
                  {isLoading ? 'Logging in...' : 'Log In'}
                </button>
              </div>
            </div>
            {welcome && <p style={{ color: 'green', textAlign: 'center', marginTop: '10px' }}>{welcome}</p>}
            {error && <p style={{ color: 'red', textAlign: 'center', marginTop: '10px' }}>{error}</p>}
            <div className="form-group m-t-10 mb-0 row">
              <div className="col-sm-7 m-t-20">
                <a href="pages-recoverpw.html" className="text-muted">
                  <i className="mdi mdi-lock" />{' '}
                  <small>Forgot your password ?</small>
                </a>
              </div>
              <div className="col-sm-5 m-t-20">
                <a href="/register" className="text-muted">
                  <i className="mdi mdi-account-circle" />{' '}
                  <small>Create an account ?</small>
                </a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  {/* jQuery  */}
  {/* App js */}
</>
    )
}